<template>
    <div>
    <p :class="{'red--text':rule}">{{label}} {{required ? ' *': ''}}</p>
    <v-btn-toggle style="box-shadow: none !important;"  class="button--day" :class="{'hidden-sm-and-down':val.length>8}" multiple v-model="val">
        <v-btn color="light-green" class="button--day--item" depressed large v-for="(item, index) in items" :key="item" :value="item"> {{ ' ' +item + ' '}} </v-btn>
    </v-btn-toggle>

    <div v-if="val.length>8" :class="{'hidden-md-and-up':val.length>8}" style="background: " >
        <v-btn-toggle style="box-shadow: none !important;"  class="button--day" multiple v-model="val">
            <v-btn color="light-green" class="button--day--item" depressed large v-for="(item, index) in items.slice(0,items.length/2)" :key="item" :value="item"> {{ ' ' +item + ' '}} </v-btn>
        </v-btn-toggle>
        <v-btn-toggle style="box-shadow: none !important; margin-top: 8px"  class="button--day" multiple v-model="val">
            <v-btn color="light-green" class="button--day--item" depressed large v-for="(item, index) in items.slice(items.length/2,items.length)" :key="item" :value="item"> {{ ' ' +item + ' '}} </v-btn>
        </v-btn-toggle>
    </div>
        <p style="margin-top: 8px;" :style="{visibility: !rule ? 'hidden' : 'visible'}" class="caption red--text">Campo requerido </p>
    </div>
</template>

<script>
    export default {
        name: "multiple-select-input",
        props: ['label','value', 'items', 'required'],
        data: ( ) => ({
            val: [],
            first: true,
        }),
        computed: {
            rule () {
                return this.required && !this.first && this.val.length === 0
            }
        },
        watch: {
            val: function (val) {
                this.$emit('input', val)
                if(this.first) this.first = false
            }
        },
        created() {
            this.val = this.value
        }
    }
</script>

<style scoped>

</style>